import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { CommonService } from '../services/common.service';
import moment from 'moment';
import * as $$ from 'jquery';
// import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
    selector: 'app-choix-equipes',
    templateUrl: './choix-equipes.component.html',
    styleUrls: ['./choix-equipes.component.css'],
    standalone: false
})
export class ChoixEquipesComponent implements OnInit {
  @Input() mouvement;
  @Input() date;
  @Input() tournee;
  @Input() depuisEditTournee;
  @ViewChild('msg') msg;
  @ViewChild('qualifEq') qualifEq;
  @Output() hidefunction = new EventEmitter<any>();
  @Output() save = new EventEmitter<any>();
  dataQualification = [];
  dataQualificationTrue = [];
  listPersodefault = [];
  listPersoPonctuel = [];
  objEquipe: any = {};
  selectedQual = {};
  listQualification: any[] = [];
  societe: any = {};
  error
  loadingIndicator: Boolean = false;
  constructor(public common: CommonService,
    public modalService: BsModalService) { }

  ngOnInit() {
    this.societe = this.common.local.getObject('paramSociete') || {};
    this.parseMouvement();
  }

  searchPersodefault(event, qualif) {
    this.listPersodefault = [];
    const mvt = this.objEquipe['mouvement'] || { id: 0 };
    console.log()
    const date = moment(this.date).format('DD/MM/YYYY');
    // if (mvt.dateEnlevement && typeof mvt.dateEnlevement === 'string' &&
    //   (mvt.dateEnlevement || '').match(/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/)) {
    //   date = (moment(mvt.dateEnlevement, 'DD/MM/YYYY').isValid() ?
    //     moment(mvt.dateEnlevement, 'DD/MM/YYYY').format('DD/MM/YYYY') : moment().format('DD/MM/YYYY'));
    // } else {
    //   date = moment(mvt.dateEnlevement, 'YYYY-MM-DD').format('DD/MM/YYYY');
    // }

    const param = {
      'servlet': 'DBGetListChauffeurRH',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'DATE': {
          'typeParam': 'date',
          'valeur': date
        },
        'IS_MULTIBENNE': {
          'typeParam': 'boolean',
          'valeur': false
        },
        'FILTRE_TEXTE': '' + event,
        'CLEF_QUALIFICATION': {
          'typeParam': 'int',
          'valeur': qualif && this.societe['priseEnCompteQualification'] ? qualif.id : 0
        },
        'IS_FILTRER_INTERIMAIRES': {
          'typeParam': 'boolean',
          'valeur': false
        },
        'IS_FILTRER_INDISPONIBLES': {
          'typeParam': 'boolean',
          'valeur': false
        },
        'IS_FILTRER_JOUR_TRAVAIL': {
          'typeParam': 'boolean',
          'valeur': false
        },
        'IS_FILTRER_CHAUFFEUR': {
          'typeParam': 'boolean',
          'valeur': false
        },
        'IS_FILTRER_INTERIMAIRES_ASSIGNATION': {
          'typeParam': 'boolean',
          'valeur': false
        },
        'NE_PAS_INCLURE_INTERIMAIRE': {
          'typeParam': 'boolean',
          'valeur': true
        },
        'FILTRER_VISIBLE_PLANNING': {
          'typeParam': 'boolean',
          'valeur': true
        },
        'FILTRER_ENTRETIEN_BAC': {
          'typeParam': 'boolean',
          'valeur': false
        },
        'FILTRER_CONTRAT_PERSO': {
          'typeParam': 'boolean',
          'valeur': true
        },
        'AJOUTER_INTERIMAIRE_EN_MISSION': {
          'typeParam': 'boolean',
          'valeur': false
        },
      }
    };
    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        this.listPersodefault = [...[{ id: 0, libelleObjetEntite: 'A définir' }], ...(datas.data || [])];
        this.listPersodefault.forEach(elt => {
          if (elt.id) {
            elt.libelleObjetEntite = `${elt.matricule || ''} ${elt.nom || ''} ${elt.prenom || ''}`
          }
        });
      }
    });
  }

  searchPersoPonctuel(event, qualif) {
    this.listPersoPonctuel = [{ id: 0, libelleObjetEntite: 'A définir' }];
    const mvt = this.objEquipe['mouvement'] || { id: 0 };
    const bon = mvt.bon || { id: 0 };
    const periode = mvt.periode;
    // const date = moment(mvt.dateEnlevement, 'YYYY-MM-DD').format('DD/MM/YYYY');
    const date = moment(this.date).format('DD/MM/YYYY');

    const camion = mvt.camion;
    const tabClefBon = [];
    this.objEquipe['listeMouvements'] = this.objEquipe['listeMouvements'] || [];
    this.objEquipe['listeMouvements'].forEach(elt => {
      const b = elt.bon || { id: 0 };
      // tabClefBon.push('' + (b ? b.id : 0));
      if (bon.id !== b.id) {
        tabClefBon.push({
          'typeParam': 'int',
          'valeur': '' + (b ? b.id : 0)
        });
      }
    });
    const listChauff = [];
    if (this.objEquipe['chauffeur']) {
      listChauff.push(this.objEquipe['chauffeur'].id || 0);
    }
    this.objEquipe['listePersonnelParPoste'] = [...(this.objEquipe['listePersonnelParPoste'] || [])];
    this.objEquipe['listePersonnelParPoste'].forEach(elt => {
      if (elt.chauffeur) {
        listChauff.push(elt.chauffeur.id || 0);
      }
    })
    const param = {
      'servlet': 'DBGestionTournee',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'true',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 8
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'CLEF_BON_EXCLU': {
          'typeParam': 'int',
          'valeur': bon ? bon.id : 0
        },
        'CLEF_PERIODE': {
          'typeParam': 'int',
          'valeur': periode ? periode.id : 0
        },
        'DATE_MOUV': {
          'typeParam': 'date',
          'valeur': date
        },
        'CLEF_CAMION': {
          'typeParam': 'int',
          'valeur': camion ? camion.id : 0
        },
        'LISTE_CLEF_BONS_EXCLUS': tabClefBon,
        'CRITERE': '' + event,
        'CLEF_QUALIF_PERSONEL': {
          'typeParam': 'int',
          'valeur': qualif && this.societe['priseEnCompteQualification'] ? qualif.id : 0
        },
        'FILTRER_VISIBLE_PLANNING': {
          'typeParam': 'boolean',
          'valeur': true
        },
        'FILTRER_CONTRAT_PERSO': {
          'typeParam': 'boolean',
          'valeur': true
        },
        'APPLIQUER_REMPLACANT': {
          'typeParam': 'boolean',
          'valeur': true
        },
      }
    };
    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        const data = datas.data || [];
        this.listPersoPonctuel = [];
        data.forEach(elt => {
          const existe = listChauff.find(t => t === elt.id);
          if (!existe) {
            if (elt.id) {
              elt.libelleObjetEntite = `${elt.matricule || ''} ${elt.nom || ''} ${elt.prenom || ''}`
            }
            // elt.libelleObjetEntite = `${elt.matricule || ''} ${elt.nom || ''} ${elt.prenom || ''}`;
            this.listPersoPonctuel.push(elt);
          }
        });
      }
    });
  }

  searchQualification(lead) {
    const list = this.common.getType('qualificationEquipe') || [];
    const test = [];
    if (lead) {
      list.forEach(elt => {
        if (elt.chauffeur) {
          test.push(elt);
        }
      });
      this.dataQualificationTrue = test;
    } else {
      if (list.length) {
        this.selectedQual = list[0]
      }
      this.dataQualification = list;
    }
  }

  addLigne() {
    const obj = Object.assign({}, this.selectedQual);
    this.selectedQual = false;
    const ctrl = this;
    ctrl.objEquipe['listePersonnelParPoste'] = ctrl.objEquipe['listePersonnelParPoste'] || [];
    ctrl.objEquipe['listePersonnelParPoste'].push({ id: 0, poste: { id: 0, qualification: obj } });
    ctrl.objEquipe['listePersonnelParPoste'] = [...(ctrl.objEquipe['listePersonnelParPoste'] || [])];
    console.log(ctrl.objEquipe['listePersonnelParPoste']);
  }

  deleteLigne(row) {
    const ctrl = this;
    ctrl.objEquipe['listePersonnelParPoste'] = ctrl.objEquipe['listePersonnelParPoste'].filter(elt => elt !== row);
  }

  closeModalEquipe() {
    this.objEquipe = {};
    this.selectedQual = false;
  }

  objMvtEquipe() {
    const ObjetRetour: any = {};

    console.log(this.objEquipe)
    ObjetRetour.listePersonnelParPoste = [];
    ObjetRetour.listePersonnelParPosteMvt = [];
    ObjetRetour.listePostes = [];
    ObjetRetour.leaderEquipe = this.objEquipe['leaderEquipe'];
    ObjetRetour.qualificationLeader = this.objEquipe['qualificationLeader'];
    ObjetRetour.chauffeur = this.objEquipe['chauffeur'];
    ObjetRetour.modeEquipe = this.objEquipe['modeEquipe'] || false;
    this.objEquipe['listePersonnelParPoste'] = this.objEquipe['listePersonnelParPoste'] || [];
    ObjetRetour.equipeDefinie = this.objEquipe['listePersonnelParPoste'].length ? true : false;

    this.objEquipe['listePersonnelParPoste'].forEach(elt => {
      ObjetRetour.listePostes.push(elt.poste);
      const defaut = {
        id: 0,
        poste: elt.poste,
        chauffeur: elt.personnelDefaut || { id: 0 }
      };
      const ponctuel = {
        id: 0,
        poste: elt.poste,
        chauffeur: elt.chauffeur || { id: 0 }
      }
      ObjetRetour.listePersonnelParPoste.push(defaut);
      ObjetRetour.listePersonnelParPosteMvt.push(ponctuel);
    });
    ObjetRetour.equipeDefinie = ObjetRetour.listePostes.length > 0 ? true : false;
    return ObjetRetour;
  }

  revertEquipe() {
    this.objEquipe['leaderEquipe'] = {};
    this.objEquipe['modeEquipe'] = false;
    this.objEquipe['listePersonnelParPoste'] = [];
  }

  fermer() {
    this.closeModalEquipe();
    this.hidefunction.emit();
  }

  parseMouvement() {
    const ctrl = this;
    const objEquipe = {
      listePersonnelParPoste: []
    };
    ctrl.mouvement['listePersonnelParPoste'] = ctrl.mouvement['listePersonnelParPoste'] || [];
    ctrl.mouvement['listePersonnelParPoste'].forEach(element => {
      objEquipe['listePersonnelParPoste'].push(Object.assign({}, element))
    });
    const data = Object.assign({}, ctrl.mouvement);
    ctrl.objEquipe = data
    ctrl.objEquipe['listePersonnelParPoste'] = objEquipe['listePersonnelParPoste'] || [];
    console.log(ctrl.objEquipe);
  }

  saveFct() {
    const ctrl = this;
    console.log(this.objEquipe)
    if (!ctrl.objEquipe.qualificationLeader) {
      ctrl.error = "Vous devez sélectionner un poste.";
      this.common.openModal(ctrl.modalService, ctrl.msg)
      return false;
    }
    this.save.emit(this.objEquipe);
  }

  clickAddPost() {
    const ctrl = this;
    this.common.openModal(ctrl.modalService, ctrl.qualifEq)
  }
}
